const KeenSlider = window.KeenSlider

const { useArrows, useProgress, setInitialised } = window.BAO.Carousel.plugins

class FitguideCarousel extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.els.slide.elements.length < 2) return

    this.carousel = this.setupCarousel()

    const sizeGuidePanel = this.closest('.sgd-Tabs_Panel')

    this.observer = new MutationObserver(() => {
      if (sizeGuidePanel.classList.contains('sgd-Tabs_Panel-active')) {
        setTimeout(() => {
          this.reinitializeSlider()
        }, 400)
      }
    })

    this.observer.observe(sizeGuidePanel, {
      attributes: true,
      attributeFilter: ['class'],
    })
  }

  disconnectedCallback () {
    if (this.observer) {
      this.observer.disconnect()
    }
    if (this.carousel) {
      this.carousel.destroy()
    }
    super.disconnectedCallback()
  }

  reinitializeSlider () {
    if (this.carousel) {
      this.carousel.destroy()
    }
    this.carousel = this.setupCarousel()
  }

  onSlideChanged (slider) {
    const slides = slider.slides
    const activeIndex = slider.track.details.rel

    slides.forEach((slide, index) => {
      slide.classList.toggle('sgd-FitGuide_Fit-active', index === activeIndex)
    })
  }

  setupCarousel () {
    const slides = Array.from(
      this.els.slides.element.querySelectorAll(this.els.slide.selector),
    )
    const activeIndex = slides.findIndex(slide =>
      slide.classList.contains('sgd-FitGuide_Fit-active'),
    )
    const initialIndex = activeIndex !== -1 ? activeIndex : 0
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        slideChanged: this.onSlideChanged,
        mode: 'snap',
        initial: initialIndex,
        slides: {
          perView: 1.25,
          origin: 'center',
        },
      },
      [
        setInitialised(),
        useArrows({
          container: this.els?.arrows?.element,
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        useProgress({
          container: this.els?.progress?.element,
          progressbar: this.els?.progressbar?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('fitguide-carousel')) {
  customElements.define('fitguide-carousel', FitguideCarousel)
}
